import { BNIsh, NonSpecificConstruction, utils } from "@malloc-protocol/sdk";
import { display } from "@mui/system";
import { TokenInfo } from "@solana/spl-token-registry";
import { PublicKey } from "@solana/web3.js";
import BN from "bn.js";
import { useEffect, useState } from "react";
import { UpdateSourceFn } from "../../interfaces";
import { getMint } from "../../utils/spl-tokens";
import { LIGHT_1 } from "../colors";
import InputGroup, { InputField } from "../inputs/input-slider";

const TokenLine = (props: {
  tok?: TokenInfo;
  mint?: string | PublicKey;
  amount?: BNIsh;
  onClick?: (tok: TokenInfo) => void;
  updateFn?: UpdateSourceFn;
  inputMints?: NonSpecificConstruction["source"]["mints"];
}) => {
  const { tok: _tok, mint } = props;
  const [tok, setTok] = useState<TokenInfo | null>(null);

  useEffect(() => {
    if (!mint) return;
    getMint(mint).then((_tok) => {
      if (_tok) setTok(_tok);
      else {
        setTok({
          chainId: 0,
          address: mint.toString(),
          name: "Unkown token",
          decimals: 6,
          symbol: "UNKOWN",
        });
      }
    });
  }, [mint]);

  useEffect(() => {
    if (_tok) setTok(_tok);
  }, [_tok]);
  if (!tok) {
    return <div>Loading...</div>;
  }
  return (
    <div
      style={{ cursor: "pointer" }}
      onClick={() => {
        if (props.onClick) props.onClick(tok);
      }}
    >
      {tok.logoURI && <img src={tok.logoURI} style={{ height: "14px" }} />}{" "}
      {props.amount
        ? utils.tokens.toReadableNumber(new BN(props.amount), tok.decimals)
        : ""}{" "}
      {tok.symbol}
      {props.updateFn != undefined && (
        <InputField
          type="number"
          value={
            props.amount
              ? parseFloat(
                  utils.tokens.toReadableNumber(
                    new BN(props.amount),
                    tok.decimals
                  )
                )
              : null
          }
          size="small"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            if (!props.updateFn || !props.inputMints || !props.mint) return;
            let newValue = utils.tokens.fromReadableNumber(
              Number(event.target.value === "" ? "0" : event.target.value),
              tok.decimals
            );

            props.inputMints[props.mint.toString()] = newValue;
            props.updateFn(props.inputMints);
          }}
          style={{
            color: LIGHT_1,
          }}
        />
      )}
    </div>
  );
};

export default TokenLine;
